module.exports = __webpack_public_path__ + "img/9791185082080.4868f256.jpg";